// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"9c468ac6","136":"2d33ae26","192":"2f4bc218","212":"5e783b80","288":"3e474f65","364":"9f899b9e","380":"c765efaa","428":"c59c6a58","496":"6bf91087","512":"5f1a9667","576":"7a7427a1","592":"599f76a2"}[chunkId] + ".chunk.js";
};